/**
 * Created by Tom.Jaeschke on 6/23/2017.
 */
import { CommonDateFunctions } from '@ups/xplat/utils';

export class PerDiemViewpointSideUpdate {
  KeyId: number;
  ServiceDate?: Date;
  ExpirationDate?: Date;
  DocType: string;
  Notes: string;
  JobNum: string = 'n/a'; //won't be used on the C# side

  // This is to fix the problem where Date gets translated to UTC during original JSON.stringify(). This method overrides the dates and translates them to string so no conversion as in some timezones the date can change as well when translating to UTC
  toJSON() {
    return {
      KeyId: this.KeyId,
      ServiceDate: CommonDateFunctions.ToDateString(this.ServiceDate),
      ExpirationDate: CommonDateFunctions.ToDateString(this.ExpirationDate),
      DocType: this.DocType,
      Notes: this.Notes,
      JobNum: this.JobNum,
    };
  }
}
